import { render, staticRenderFns } from "./TrialSettings.vue?vue&type=template&id=6f8f87f8&scoped=true&"
import script from "./TrialSettings.vue?vue&type=script&lang=js&"
export * from "./TrialSettings.vue?vue&type=script&lang=js&"
import style0 from "./TrialSettings.vue?vue&type=style&index=0&id=6f8f87f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f87f8",
  null
  
)

export default component.exports